<template>
  <GalleryReviewCard :aria-label :review @visible="emit('visible')" />
</template>

<script setup lang="ts">
import type { ReviewWithCount } from '~/scopes/product-core/components/presentationals/GalleryNew/GalleryNew.types'

import GalleryReviewCard from './components/GalleryReviewCard.vue'

defineProps<{
  review: ReviewWithCount
  ariaLabel?: string
}>()

const emit = defineEmits<{
  (e: 'visible'): void
}>()
</script>
